<template>
  <section class="sm-list">
    <div
      class="sm-list-inner"
      :class="showGroupActions ? 'action' : ''"
    >
      <template v-if="list.length">
        <group-actions
          v-if="showGroupActions"
          :groupActions="availableGroupActions"
          :selected="checkedItemIds.length"
          @triggerGroupAction="groupAction"
          @remove-selection="removeSelection"
        />
        <table v-if="viewPort == 'large'" class="sm-table sm-list__table">
          <thead class="sm-table__head">
            <tr class="sm-txt-upper">
              <th
                v-if="showCheckboxes"
                class="sm-table__head-item checkbox"
              >
                <checkbox-block
                  @input.native="toggleAll"
                  v-model="checkAll"
                />
              </th>
              <th
                class="sm-table__head-item number sort"
                :class="currentSort === 'mail_number' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('mail_number')"
              >
                ID <include-svg v-if="!noSort" :name="'icon-arrow-b-bold'" />
              </th>
              <th
                class="sm-table__head-item sm-txt-center pmb sort"
                :class="currentSort === activeColumn && currentSortDir === 'asc' ? 'active' : ''"
                >
                <div style="display: flex;align-items: center;gap: 5px;">
                  <div class="sm-columns__controls-dropdown">
                    <span style=""  @click="togglePopup()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-funnel" viewBox="0 0 16 16">
                        <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z"/>
                      </svg>
                    </span>

                    <ul
                  v-if="menuPopup"
                  v-click-outside="hidePopup"
                  class="sm-columns__controls-dropdown-list"
                >
                  <li>
                    <checkbox-block
                      :text="'Mailbox number'"
                      @input="value => handleToggleCustomerColumn(value , 'account_number')"
                      :value="activeColumn == 'account_number'"
                    />
                  </li>
      
                  <li>
                    <checkbox-block
                      :text="`Customer's name`"
                      @input="value => handleToggleCustomerColumn(value , 'customer_full_name')"
                      :value="activeColumn == 'customer_full_name'"
                    />
                  </li>
                  <li>
                    <checkbox-block
                      :text="`Business name`"
                      @input="value => handleToggleCustomerColumn(value , 'customer_company_name')"
                      :value="activeColumn == 'customer_company_name'"
                    />
                  </li>
                    </ul>
                  </div>
                <div @click="sortBy(activeColumn)" style="font-weight: 600;">
                  {{customerColumnHead[activeColumn]}} <include-svg v-if="!noSort" :name="'icon-arrow-b-bold'" />
                </div>
              </div>
              </th>
              <th
                class="sm-table__head-item sender sort"
                :class="currentSort === 'sender' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('sender')">
                Sender <include-svg v-if="!noSort" :name="'icon-arrow-b-bold'" />
              </th>

              <th
                class="sm-table__head-item date sort"
                :class="currentSort === 'received_at' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('received_at')"
                >
                Posted date <include-svg v-if="!noSort" :name="'icon-arrow-b-bold'" />
              </th>

              <th
                class="sm-table__head-item type sort"
                :class="currentSort === 'mail_type_id' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('mail_type_id')">
                Type <include-svg v-if="!noSort" :name="'icon-arrow-b-bold'" />
              </th>
              <th class="sm-table__head-item qty">Qty.</th>
              <th
                class="sm-table__head-item date sort"
                :class="currentSort === 'received_at' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('received_at')">
                Request Date <include-svg v-if="!noSort" :name="'icon-arrow-b-bold'" />
              </th>
              <th
                class="sm-table__head-item status sort"
                :class="currentSort === 'status_label' && currentSortDir === 'asc' ? 'active' : ''"
                @click="sortBy('status_label')"
              >
                Status <include-svg v-if="!noSort" :name="'icon-arrow-b-bold'" />
              </th>
              <th class="sm-table__head-item request">
                <span v-if="showActions">Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <single-mail
              v-for="item in list"
              :key="item.id"
              v-reference
              :mail="item"
              :startActive="checkedItemIds.includes(item.id)"
              :checkboxes="showCheckboxes"
              :actions="showActions"
              @change-selection="changeSelection"
              @remove-selection="removeSelection"
              @action="itemAction"
              :activeCustomerColumn="activeColumn"
            />
          </tbody>
        </table>

        <div v-else class="sm-mobile-table sm-list__mobile">
          <div class="sm-mobile-table-item header">
            <div class="sm-mobile-table-item-row">
              <div class="sm-mobile-table-item-row-th sender">Sender</div>
              <div class="sm-mobile-table-item-row-th pmb sm-txt-center">Box</div>
              <div class="sm-mobile-table-item-row-th date">Posted date</div>
              <!-- <div class="sm-mobile-table-item-row-th date">Request date</div> -->
            </div>
          </div>
          <single-mail
            v-for="item in list"
            :key="item.id"
            v-reference
            :edit="showCheckboxes"
            :actions="showActions"
            :mail="item"
            :startActive="checkedItemIds.includes(item.id)"
            @change-selection="changeSelection"
            @remove-selection="removeSelection"
            @action="itemAction"
          />
        </div>
      </template>

      <empty-mail
        v-else
        :tab="'new'"
      />
    </div>
  </section>
</template>

<script>
import SingleMail from '@/views/admin/pages/mail/components/SingleMail';
import MailGroupActions from '@/components/mail/MailGroupActions';
import EmptyMail from '@/components/mail/EmptyMail';
import Checkbox from '@/components/Checkboxes';
import MailParams from '@/settings/mail';
import ViewPort from '@/mixins/ViewPort';
import vClickOutside from "v-click-outside";

export default {
  name: 'single-maillist',
  components: {
    'single-mail': SingleMail,
    'empty-mail': EmptyMail,
    'checkbox-block': Checkbox,
    'group-actions': MailGroupActions,
  },
  props: {
    showActions: {
      type: Boolean,
      default: true
    },
    showCheckboxes: {
      type: Boolean,
      default: true
    },
    preselectedItems: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    noSort: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkedItemIds: [],
      checkAll: false,
      currentSort: 'id',
      currentSortDir: 'desc',
      singleMailVNodes: [],
      allowedBreakpoints: [
        'small',
        'medium',
        'large'
      ],
      menuPopup: false,
      activeColumn:'account_number',
      customerColumnHead:{
        'account_number': 'Box',
        'customer_full_name': 'Customer name',
        'customer_company_name': 'Business name',
      },
      selectedItemsHashMap:{}
    };
  },
  created() {
    const order = this.$route.query.order
    // this.checkedItemIds = this.selectedItems;

    if(order){
      const decodedString = decodeURIComponent(order);
      const {column} = JSON.parse(decodedString)
      this.activeColumn = Object.keys(this.customerColumnHead).includes(column) ? column : 'account_number'
    }
  },
  computed: {
    showGroupActions() {
      return this.showActions && this.checkedItemIds.length;
    },

    availableGroupActions() {
      return MailParams.available_actions.admin.group.map(item => {
        return {
          name: item,
          text: MailParams.actions[item].text || item.replace(/_/g, ' '),
          icon: MailParams.actions[item].btn.icon,
          disabled: item === "pick_up_signature" && new Set(Object.values(this.selectedItemsHashMap)).size > 1 ? true : false
        }
      })
    }
  },
  mixins: [ViewPort],
  methods: {
    sortBy(key) {
      if (this.noSort)
        return;

      if (key === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'desc' ? 'asc' : 'desc';
      } else {
        this.currentSortDir = 'desc';
      }
      this.currentSort = key;

      this.$emit('sort', {
        column: this.currentSort,
        direction: this.currentSortDir
      });
    },
    changeSelection(data) {
      if (data.val == true) {
        if (this.checkedItemIds.includes(data.id))
          return;

        this.checkedItemIds.push(data.id);
        this.selectedItemsHashMap = {...this.selectedItemsHashMap , [data.id]: data.account_id}
      } else {
        this.checkedItemIds = this.checkedItemIds.filter(id => id !== data.id);

        const { [data.id]: _, ...newSelectedItemsHashMap } = this.selectedItemsHashMap;

        this.selectedItemsHashMap = newSelectedItemsHashMap
      }

      this.$emit('select', this.checkedItemIds);
    },
    removeSelection(deep) {
      this.checkAll = false;

      if (deep)
        this.singleMailVNodes.forEach(vnode => vnode.componentInstance.setActive(false));

      this.$emit('select', this.checkedItemIds);
    },
    toggleAll() {
      this.checkAll = !this.checkAll;

      const itemsHashMap = {}

      this.list.forEach((item, index) => {
        if (!this.isItemProcessed(item)) {
          this.singleMailVNodes[index].componentInstance.setActive(this.checkAll);
          itemsHashMap[item.id] = item.account_id
        }
      })

      this.selectedItemsHashMap = itemsHashMap

      // this.singleMailVNodes.forEach(vnode => vnode.componentInstance.setActive(this.checkAll));
    },
    itemAction(data) {
      this.$emit('action', data);
    },
    groupAction(action) {
      const data = {
        ids: this.checkedItemIds,
        action
      }

      if(action === "pick_up_signature") {
        const accountIds = new Set(Object.values(this.selectedItemsHashMap))
        if(accountIds.size === 1) {
          data.account_id = [...accountIds][0]

        } else {
          console.error("Multiple account IDs detected. Unable to proceed with signature pick-up.");
          return; // Optionally handle the error case where there are multiple or no account IDs
        }     
      } 

      this.$emit('groupAction', data);

      // this.removeSelection(true);
    },
    isItemProcessed(item) {
      return (
        item.is_forward_complete ||
        item.is_pick_up_complete ||
        item.mark_as_pick_up_complete ||
        item.is_shred_complete ||
        item.is_junk
      );
    },
    togglePopup() {
      this.menuPopup = !this.menuPopup;
    },
    hidePopup() {
      this.menuPopup = false;
    },
    handleToggleCustomerColumn(val , active){
      // if(Object.keys(this.customerColumnHead).includes(this.currentSort)){
      //   this.sortBy(active)
      // }
      this.activeColumn = active
    },
  },
  directives: {
    reference: {
      bind(el, binding, vnode) {
        vnode.context.singleMailVNodes.push(vnode);
      },
      unbind(el, binding, vnode) {
        vnode.context.singleMailVNodes = vnode.context.singleMailVNodes.filter(node => node.key !== vnode.key);
      }
    },
    clickOutside: vClickOutside.directive
  
  },
  watch: {
    checkedItemIds(val) {
      this.$emit('selected', val);
    },
    list() {
      this.checkAll = false;
      this.checkedItemIds = [];
    },
    showCheckboxes(val) {
      if (val)
        this.checkedItemIds = this.preselectedItems.filter((item, index) => {
          return this.list.find(li => li.id == item);
        });
    },
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/mail/_list.scss';



  .sm-columns__controls-dropdown {
    position: relative;
    // height: 48px;
    // min-width: 156px;
    cursor: pointer;


  &-list {
    position: absolute;
    top: calc(100% + 12px);
    left: 50%;
    -webkit-transform: translate3d(-50%,0,0);
    transform: translate3d(-50%,0,0);
    background-color: var(--white);
    max-width: 360px;
    min-width: 160px;
    width: max-content;
    // pointer-events: none;
    // opacity: 1;
    -webkit-transition: display .2s linear;
    transition: display .2s linear;
    padding: 14px 16px;
    -webkit-box-shadow: 0 4px 20px rgba(56,12,52,.1);
    box-shadow: 0 4px 20px rgba(56,12,52,.1);
    border-radius: 6px;
    z-index: 100;

    &:before {
    content: '';
    position: absolute;
    top: -20px;
    left: 0;
    width: 100%;
    height: 20px;
    }

    & > li {
    display: flex;
    position: relative;
    height: 36px;
    padding: 0 5px;
    cursor: pointer;
    text-transform: capitalize;
    }

    &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 100%;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        border-bottom: 16px solid var(--white);
        border-right: 14px solid rgba(255,255,255,0);
        border-left: 14px solid rgba(255,255,255,0);
    }
  }

}

</style>
